/*
 * macade-header-drawer.js
 *
 * Remembers the gender chosen in the drawer's first view (Men/Women) so the
 * chooser is skipped on later visits. The drawer state itself is CSS-only
 * (hidden radios + :checked); this script only flips the right radio on load
 * and records the choice in localStorage.
 *
 * Storage value is the tab radio's index ("1" / "2"), matching the
 * #MacadeDrawerTab-<index> ids rendered by macade-header-drawer.liquid.
 */
(function () {
  var STORAGE_KEY = 'macade-drawer-gender';

  function readStored() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function writeStored(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* private mode / storage disabled — chooser just shows every time */
    }
  }

  function init() {
    var drawer = document.querySelector('.macade-drawer');
    if (!drawer) return;

    var radios = drawer.querySelectorAll('input[name="MacadeDrawerTab"]');
    if (!radios.length) return;

    // Restore a previously chosen gender so the chooser is skipped. Guarded
    // by existence in case the stored index no longer maps to a tab.
    var stored = readStored();
    if (stored) {
      var target = drawer.querySelector('#MacadeDrawerTab-' + stored);
      if (target) target.checked = true;
    }

    // Persist the choice whenever a gender radio (not "home") becomes selected,
    // from either the first-view chooser or the in-detail tabs.
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked || radio.id === 'MacadeDrawerTab-home') return;
        writeStored(radio.id.replace('MacadeDrawerTab-', ''));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
